import { useState } from 'react';
import { wait } from 'utils/wait';
import { TAnimatedPageDirection } from '../types';

export const useAnimatedPage = (duration = 500) => {
  const [direction, setDirection] = useState<TAnimatedPageDirection | null>(null);

  const animate =
    (callback: VoidFunction, { direction }: { direction: TAnimatedPageDirection }) =>
    async () => {
      setDirection(direction);
      // animation out
      await wait(duration);
      callback();
      // animation in
      await wait(duration);
      setDirection(null);
    };

  return { isInProgress: !!direction, direction, animate };
};
